import React, {Component} from 'react';

class HeaderLogo extends Component {
  render() {
    return(
      <div>
        <h2 className="pp">Pasarpolis</h2>
        <h2 className="bpjs">BPJS</h2>
        <h4>BPJS Ketenagakerjaan</h4>
      </div>
    )
  }
}

export default HeaderLogo;



// WEBPACK FOOTER //
// ./src/component/Common/header/header_logo.js